import { render } from "./general_masters.vue?vue&type=template&id=93a7bd02"
import script from "./general_masters.vue?vue&type=script&setup=true&lang=js"
export * from "./general_masters.vue?vue&type=script&setup=true&lang=js"

import "./general_masters.vue?vue&type=style&index=0&id=93a7bd02&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/general_masters.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "93a7bd02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('93a7bd02', __exports__)) {
    api.reload('93a7bd02', __exports__)
  }
  
  module.hot.accept("./general_masters.vue?vue&type=template&id=93a7bd02", () => {
    api.rerender('93a7bd02', render)
  })

}


export default __exports__